/** @format */

import { createAction, props } from '@ngrx/store';
import { LoyaltyBalance } from '@shared/data-access/interfaces';

export const enableFooter = createAction('[PDP Product Container] Enable Footer');

export const loyaltyBalanceUpdated = createAction(
  '[PDP Product Container] Loyalty Balance Updated',
  props<{ loyaltyBalance: Partial<LoyaltyBalance> }>(),
);

export const authEmptyLoyaltyBalanceUpdated = createAction(
  '[PDP Product Container] Auth Empty Loyalty Balance Updated',
  props<{ loyaltyBalance: object }>(),
);

export const authLoyaltyBalanceUpdatedError = createAction(
  '[PDP Product Container] Auth Check Loyalty Balance Error',
  props<{ loyaltyBalance: object }>(),
);

export const pointSummaryLoyaltyBalanceUpdatedSuccess = createAction(
  '[PDP Product Container] Points Summary Loyalty Balance Success',
  props<{ loyaltyBalance: Partial<LoyaltyBalance> }>(),
);

export const pointSummaryLoyaltyBalanceUpdatedError = createAction(
  '[PDP Product Container] Points Summary Loyalty Balance Error',
  props<{ loyaltyBalance: object }>(),
);

export const changeStoreRequested = createAction(
  '[PDP Product Image Viewer] Change Store Requested',
);

export const loyaltyBalanceUpdateActions = [
  loyaltyBalanceUpdated,
  authEmptyLoyaltyBalanceUpdated,
  authLoyaltyBalanceUpdatedError,
  pointSummaryLoyaltyBalanceUpdatedSuccess,
  pointSummaryLoyaltyBalanceUpdatedError,
] as const;
